import * as def from '@/definitions'
import { PatternBaseLayer } from './patternBaseLayer'
import { ColorConstruct } from '@/utilityModels/colorConstruct'
import { Layer } from './layer';
import { PathHelper } from '@/helper/pathHelper'
import { ArrayHelper } from '@/helper/arrayHelper';

// 四角形レイヤー
export class RectangleLayer extends PatternBaseLayer
{
    public get layerType() : string { return "rectangle"; }

    // 丸み(横)
    private _horizontalRadius : number = 0; 
    public get horizontalRadius() : number
    {
        return this._horizontalRadius;
    }
    public set horizontalRadius(horizontalRadius : number)
    {
        this._horizontalRadius = horizontalRadius;
    }

    // 丸み(横)
    private _verticalRadius : number = 0; 
    public get verticalRadius() : number
    {
        return this._verticalRadius;
    }
    public set verticalRadius(verticalRadius : number)
    {
        this._verticalRadius = verticalRadius;
    }

    // 作成
    public static create(x : number = 0, y : number = 0, width : number = 0, height : number = 0) : RectangleLayer
    {
        var layer = new RectangleLayer();
        layer.keepRatio = 0;
        layer.strokeColor = new ColorConstruct(0, 0, 0);
        layer.strokeWidth = 1.0;
        layer.horizontalRadius = 0;
        layer.verticalRadius = 0;
        layer.fillType = 0;
        layer.fillColor = new ColorConstruct(51 ,153, 0);
        layer.rotate = 0;
        layer.width = width;
        layer.height = height;
        layer.x = x;
        layer.y = y;

        // 初期グラデーション
        layer.addGradation(0, new ColorConstruct(0, 255, 0));
        layer.addGradation(100, new ColorConstruct(255, 255,255));
        layer.linearGradationAngle = 0;
        
        return layer;
    }

    // 複製
    public clone()
    {
        var cloned = new RectangleLayer();
        this.cloneParameter(cloned);
        return cloned;
    }

    public cloneParameter(layer : RectangleLayer)
    {
        layer.horizontalRadius = this._horizontalRadius;
        layer.verticalRadius = this._verticalRadius;
        
        super.cloneParameter(layer);
    }

    // JSON
    public toJSON()
    {
        var jsonObj = {};
        jsonObj = this.saveParameterToJson(jsonObj);
        return jsonObj;
    }

    public saveParameterToJson(jsonObject)
    {
        jsonObject.horizontalRadius = this._horizontalRadius;
        jsonObject.verticalRadius = this._verticalRadius;

        jsonObject = super.saveParameterToJson(jsonObject);

        return jsonObject;
    }

    public static createFromJsonData(jsonData : any) : RectangleLayer
    {
        var layer = new RectangleLayer();
        layer.loadParameterFromJson(jsonData);
        return layer;
    }

    public loadParameterFromJson(jsonData)
    {
        if(jsonData.horizontalRadius != null) { this._horizontalRadius = jsonData.horizontalRadius; }
        if(jsonData.verticalRadius != null) { this._verticalRadius = jsonData.verticalRadius; }

        super.loadParameterFromJson(jsonData);
    }
}